import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
  saving: false,
  deleting: false,
  list: [],
});

const termConditionsModule = {
  namespaced: true,
  state: initState(),
  mutations: {
    LOADING: (s, data) => (s.loading = data),
    SAVING: (s, data) => (s.saving = data),
    DELETING: (s, data) => (s.deleting = data),
    SET_LIST: (s, data) => (s.list = data),
    ADD_ITEM: (s, item) => s.list.push(item),
    UPDATE_ITEM: (s, item) => {
      const idx = s.list.findIndex((i) => i.id === item.id);
      if (idx !== -1) s.list.splice(idx, 1, item);
    },
    REMOVE_ITEM: (s, id) => {
      const idx = s.list.findIndex((i) => i.id === id);
      if (idx !== -1) s.list.splice(idx, 1);
    },
  },
  actions: {
    async getTermConditions({ commit }) {
      commit("LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/promotions/term-conditions/list");
        const list = res.data?.data || res.data || [];
        commit("SET_LIST", list);
        return list;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING", false);
      }
    },
    async createTermCondition({ commit }, params) {
      commit("SAVING", true);
      try {
        const res = await this.$api.post("/v1/portal/promotions/term-conditions", params);
        const item = res.data?.data || res.data;
        if (item) commit("ADD_ITEM", item);
        return item;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SAVING", false);
      }
    },
    async updateTermCondition({ commit }, params) {
      commit("SAVING", true);
      try {
        const { id, ...rest } = params;
        await this.$api.put(`/v1/portal/promotions/term-conditions/${id}`, rest);
        commit("UPDATE_ITEM", params);
        return params;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SAVING", false);
      }
    },
    async deleteTermCondition({ commit }, id) {
      commit("DELETING", true);
      try {
        const res = await this.$api.delete(`/v1/portal/promotions/term-conditions/${id}`);
        commit("REMOVE_ITEM", id);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("DELETING", false);
      }
    },
  },
};

export default termConditionsModule;
